__turbopack_context__.v({
  "container": "_223YjW_container",
  "dotSeparator": "_223YjW_dotSeparator",
  "error": "_223YjW_error",
  "footerActions": "_223YjW_footerActions",
  "quantityChange": "_223YjW_quantityChange",
});
